///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, itemCatalogDetailActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getItemCatalogDetail = function* ({ payload }) {
	const id = payload.idItem
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_ITEM_CATALOG_DETAIL(id)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(itemCatalogDetailActionCreators.getItemCatalogDetailSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))
		yield put(itemCatalogDetailActionCreators.getItemCatalogDetailFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_ITEM_CATALOG_DETAIL, getItemCatalogDetail)
}

export default sagas
